import { render } from "./AlbumViewer.vue?vue&type=template&id=0f9ae802&scoped=true&ts=true"
import script from "./AlbumViewer.ts?vue&type=script&lang=ts&external"
export * from "./AlbumViewer.ts?vue&type=script&lang=ts&external"

import "./AlbumViewer.vue?vue&type=style&index=0&id=0f9ae802&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9ae802"]])

export default __exports__